import AvailabilityToggle from '@app/components/common/AvailabilityToggle';
import { PAGE_BREAKPOINTS, STATUS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { InlineLoader, Toggle } from 'cat-ecommerce-alloy';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearLineItemNotesFocus } from '../../../../../../../../store/orders/actions';
import ShowNotesToggle from '../../../../ShoppingCartPage/ShowNotesToggle';
import styles from '../../../../styles.module.scss';
import prefToggleStyles from './preferenceToggles.module.scss';
import {
  updatePreference,
  updateImagePreference
} from '@app/store/shoppingPreferences/actions';
import { useEffect, useMemo, useRef } from 'react';
import { getLanguageDetails } from '@app/components/pages/account/shopping-preferences/utils';
import { useFormikContext } from 'formik';
const PreferenceToggles = ({
  imageSettings,
  displayAvailabityAndSourcingDetails,
  setTogglePrefs,
  isShowNotesAndImageTogles = true
}) => {
  const [t] = useTranslation();

  const { values } = useFormikContext();

  const {
    showSourcingDetailToggle: showAvailabilityBySource,
    imageSettings: imageSettingState
  } = useSelector(state => state.shoppingPreferences.shoppingPreferencesData);

  const { displayOnScreen } = imageSettings;
  const imgPreferenceRef = useRef(displayOnScreen);
  const dispatch = useDispatch();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const isRequiredFieldsLoading = useSelector(
    s => s.checkout.isRequiredFieldsLoading
  );
  const shoppingPreferenceDataStatus = useSelector(
    s => s.shoppingPreferences.shoppingPreferenceDataStatus
  );
  const getCurrentOrderStatus = useSelector(
    s => s.orders.getCurrentOrderStatus
  );
  const getDealerCustomerStoresStatus = useSelector(
    s => s.dealerCustomer.getDealerCustomerStoresStatus
  );
  const isOrderPriceAvailabilityLoading = useSelector(
    s => s.orders.isOrderPriceAvailabilityLoading
  );
  let displayLineItemNotes = useSelector(
    s => s.shoppingPreferences.shoppingPreferencesData.displayLineItemNotes
  );
  const toggleChecked = () => {
    dispatch(updateImagePreference(!displayOnScreen));
  };
  const isDealerCustomerLoading =
    getDealerCustomerStoresStatus === STATUS.PENDING ||
    getDealerCustomerStoresStatus === STATUS.IDLE;
  const isOrdersLoading =
    getCurrentOrderStatus === STATUS.PENDING ||
    getCurrentOrderStatus === STATUS.IDLE;
  const shoppingPreferencesLoading =
    shoppingPreferenceDataStatus === STATUS.PENDING ||
    shoppingPreferenceDataStatus === STATUS.IDLE;
  const getCommonVarsStatus = useSelector(s => s.common.getCommonVarsStatus);
  const isLoading =
    isRequiredFieldsLoading ||
    isOrdersLoading ||
    isDealerCustomerLoading ||
    isOrderPriceAvailabilityLoading ||
    getCommonVarsStatus === STATUS.PENDING ||
    shoppingPreferencesLoading;
  const showNotesToggleOrLoader = isLoading ? (
    <InlineLoader className="py-2 my-1" />
  ) : (
    <ShowNotesToggle />
  );
  const isStoreAvailabilityEnabled = useSelector(
    state => state.dealer?.isStoreAvailabilityEnabled
  );

  const getLanguageStatus = useSelector(s => s.footer?.getLanguageStatus);
  const supportedLanguages = useSelector(s => s.footer?.supportedLanguages);

  const languageOptions = useMemo(
    () =>
      getLanguageStatus === STATUS.RESOLVED
        ? getLanguageDetails(supportedLanguages)
        : [],
    [getLanguageStatus, supportedLanguages]
  );
  const updateUserPreferences = () => {
    if (
      displayOnScreen !== imgPreferenceRef.current ||
      ('showNotes' in values && displayLineItemNotes !== values.showNotes)
    ) {
      dispatch(
        updatePreference(
          {
            shoppingCartAddNotes: values.showNotes,
            imageSettings: imageSettingState
          },
          false,
          languageOptions
        )
      );
    }
  };
  useEffect(() => {
    window.addEventListener('beforeunload', updateUserPreferences);
    return () => {
      window.removeEventListener('beforeunload', updateUserPreferences);
    };
  }, [dispatch, values, displayOnScreen]);
  return (
    <div
      className={cn(
        prefToggleStyles['preference-toggle-container'],
        'd-flex pb-2 mt-md-2'
      )}
    >
      {isShowNotesAndImageTogles && (
        <>
          {!isMD && showNotesToggleOrLoader}
          <div>
            <Toggle
              id="showImages"
              className={cn(
                'u-color--DarkGray px-2 d-print-none',
                styles['shopping-cart-page__toggle']
              )}
              label={t('SHOPCART_SHOW_IMAGE')}
              labelClassName={cn(
                'd-flex align-items-end',
                styles['show-toggle__label']
              )}
              checked={displayOnScreen}
              setChecked={() => {
                dispatch(clearLineItemNotesFocus());
                toggleChecked();
              }}
              placement="start"
            />
          </div>
        </>
      )}
      {isStoreAvailabilityEnabled && (
        <AvailabilityToggle
          showAvailabilityBySource={showAvailabilityBySource}
          displayAvailabityAndSourcingDetails={
            displayAvailabityAndSourcingDetails
          }
          labelClassName={cn(
            'd-flex align-items-end',
            styles['show-toggle__label']
          )}
          setTogglePrefs={setTogglePrefs}
          placement="start"
        />
      )}
    </div>
  );
};

PreferenceToggles.propTypes = {
  imageSettings: PropTypes.shape({
    displayOnScreen: PropTypes.bool,
    displayOnPrint: PropTypes.bool
  }),
  displayAvailabityAndSourcingDetails: PropTypes.bool,
  setTogglePrefs: PropTypes.func,
  isShowNotesAndImageTogles: PropTypes.bool
};

export default PreferenceToggles;
